/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import Editor from './Editor/index'
import ImageSeriesDate from './ImageSeriesDate/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PatientAge from './PatientAge/index'
import PatientName from './PatientName/index'
import React from 'react'
import ResetAction from './ResetAction/index'
import Saving from './Saving/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Edit/EditModal/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="calc(100vw - 30px)"
 height="calc(100vh - 30px)"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Edit image"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Editor
{...childProps}
  viewPath={`${viewPath}/Editor`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<PatientAge
  viewPath={`${viewPath}/PatientAge`}
/>
<ImageSeriesDate
  viewPath={`${viewPath}/ImageSeriesDate`}
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Saving
  viewPath={`${viewPath}/Saving`}
/>
<ResetAction
  viewPath={`${viewPath}/ResetAction`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}